(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["price-filter"] && !Shopify.designMode) return;
  try {
    function initPriceFacetSliders() {
document.querySelectorAll('.price-facet').forEach((facet) => {
if (facet.dataset.sliderInitialized) return;
facet.dataset.sliderInitialized = 'true';

const minRange = facet.querySelector('[data-slider-min-range]');
const maxRange = facet.querySelector('[data-slider-max-range]');
const rangeFill = facet.querySelector('[data-slider-range-fill]');
const minInput = facet.querySelector('[data-slider-min-input]');
const maxInput = facet.querySelector('[data-slider-max-input]');

if (!minRange || !maxRange || !rangeFill) return;

const sliderMax = Number(minRange.max) || 100;
const minGap = Number(minRange.dataset.minGap) || 1;

function updateFill() {
const minPercent = Number(minRange.value) / sliderMax;
const maxPercent = Number(maxRange.value) / sliderMax;

rangeFill.style.left = 'calc(8px + (100% - 16px) * ' + minPercent + ')';
rangeFill.style.width = 'calc((100% - 16px) * ' + (maxPercent - minPercent) + ')';

if (minPercent > 0.5) {
minRange.style.zIndex = 5;
maxRange.style.zIndex = 4;
} else {
minRange.style.zIndex = 4;
maxRange.style.zIndex = 5;
}
}

function dispatchChange(input) {
if (!input) return;
input.dispatchEvent(new Event('change', { bubbles: true }));
}

minRange.addEventListener('input', () => {
if (Number(minRange.value) > Number(maxRange.value) - minGap) {
minRange.value = Number(maxRange.value) - minGap;
}
updateFill();
if (minInput) minInput.value = Number(minRange.value).toLocaleString('ja-JP');
});

maxRange.addEventListener('input', () => {
if (Number(maxRange.value) < Number(minRange.value) + minGap) {
maxRange.value = Number(minRange.value) + minGap;
}
updateFill();
if (maxInput) maxInput.value = Number(maxRange.value).toLocaleString('ja-JP');
});

minRange.addEventListener('change', () => dispatchChange(minInput));
maxRange.addEventListener('change', () => dispatchChange(maxInput));

if (minInput) {
minInput.addEventListener('change', () => {
const val = parseFloat(minInput.value.replace(/,/g, '')) || 0;
minRange.value = val;
updateFill();
});
}

if (maxInput) {
maxInput.addEventListener('change', () => {
const val = parseFloat(maxInput.value.replace(/,/g, '')) || sliderMax;
maxRange.value = val;
updateFill();
});
}

updateFill();
});
}

document.addEventListener('DOMContentLoaded', initPriceFacetSliders);
document.addEventListener('shopify:section:load', initPriceFacetSliders);
  } catch(e) { console.error(e); }
})();

})();
